import { render, staticRenderFns } from "./list.vue?vue&type=template&id=261d353b&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=261d353b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261d353b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('261d353b')) {
      api.createRecord('261d353b', component.options)
    } else {
      api.reload('261d353b', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=261d353b&scoped=true", function () {
      api.rerender('261d353b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/stadiumSuperviseSystem/swimmingSuperviseStadium/list.vue"
export default component.exports